export const MIS_REPORT_CATEGORIES = [
  { id: "all", label: "All", icon: "fa-solid fa-border-all" },
  { id: "financial", label: "Financial", icon: "fa-solid fa-coins" },
  { id: "inventory", label: "Inventory", icon: "fa-solid fa-warehouse" },
  { id: "logistics", label: "Logistics", icon: "fa-solid fa-ship" },
  { id: "procurement", label: "Procurement", icon: "fa-solid fa-cart-shopping" },
  { id: "sales", label: "Sales", icon: "fa-solid fa-receipt" },
];

export const MIS_REPORTS = [
  {
    id: "pnl-report",
    title: "Profit & Loss (P&L)",
    shortTitle: "P&L Report",
    path: "/reports/pnl-report",
    category: "financial",
    categoryLabel: "Financial",
    icon: "fa-solid fa-calculator",
    iconBg: "bg-amber-50 text-amber-700 dark:bg-amber-950/50 dark:text-amber-300",
    description:
      "Comprehensive profit and loss statement across purchases, sales, and operational overheads with margin analysis.",
  },
  {
    id: "stock-report",
    title: "Stock Inventory",
    shortTitle: "Stock Report",
    path: "/reports/stock-report",
    category: "inventory",
    categoryLabel: "Inventory",
    icon: "fa-solid fa-warehouse",
    iconBg: "bg-emerald-50 text-emerald-700 dark:bg-emerald-950/50 dark:text-emerald-300",
    description:
      "Real-time stock valuation, physical vs booked weights, material classifications, and yard storage distribution.",
  },
  {
    id: "bill-report",
    title: "Purchase Bills",
    shortTitle: "Bill Report",
    path: "/reports/bill-report",
    category: "procurement",
    categoryLabel: "Procurement",
    icon: "fa-solid fa-file-invoice-dollar",
    iconBg: "bg-blue-50 text-blue-700 dark:bg-blue-950/50 dark:text-blue-300",
    description:
      "Summary of all purchase supplier bills, custom duties, tax breakdowns, invoice statuses, and settlement balances.",
  },
  {
    id: "selling-report",
    title: "Sales & Invoicing",
    shortTitle: "Selling Report",
    path: "/reports/selling-report",
    category: "sales",
    categoryLabel: "Sales",
    icon: "fa-solid fa-receipt",
    iconBg: "bg-sky-50 text-sky-700 dark:bg-sky-950/50 dark:text-sky-300",
    description:
      "Customer sales invoice analysis, material dispatch volumes, realized prices, and gross revenue collections.",
  },
  {
    id: "lot-wise-report",
    title: "Lot-wise Segregation",
    shortTitle: "Lot-wise Report",
    path: "/reports/lot-wise",
    category: "inventory",
    categoryLabel: "Inventory",
    icon: "fa-solid fa-layer-group",
    iconBg: "bg-rose-50 text-rose-700 dark:bg-rose-950/50 dark:text-rose-300",
    description:
      "Metal segregation recovery ratios, processing yields, recovered output weights, and batch efficiency metrics.",
  },
  {
    id: "bl-wise-report",
    title: "BL-wise Shipments",
    shortTitle: "BL-wise Report",
    path: "/reports/bl-wise",
    category: "logistics",
    categoryLabel: "Logistics",
    icon: "fa-solid fa-ship",
    iconBg: "bg-cyan-50 text-cyan-700 dark:bg-cyan-950/50 dark:text-cyan-300",
    description:
      "End-to-end BL shipment tracker, shipping lines, port arrivals, customs clearance statuses, and transit milestones.",
  },
  {
    id: "container-wise-report",
    title: "Container Logistics",
    shortTitle: "Container-wise Report",
    path: "/reports/container-wise",
    category: "logistics",
    categoryLabel: "Logistics",
    icon: "fa-solid fa-boxes-packing",
    iconBg: "bg-purple-50 text-purple-700 dark:bg-purple-950/50 dark:text-purple-300",
    description:
      "Granular container status breakdown, tare vs gross weight audit, seal verifications, and yard staging records.",
  },
  {
    id: "purchase-master-wise-report",
    title: "Purchase Contracts",
    shortTitle: "Purchase Master-wise",
    path: "/reports/purchase-master-wise",
    category: "procurement",
    categoryLabel: "Procurement",
    icon: "fa-solid fa-table-list",
    iconBg: "bg-orange-50 text-orange-700 dark:bg-orange-950/50 dark:text-orange-300",
    description:
      "Consolidated purchase contract records, vendor agreements, material pricing history, and order fulfillment status.",
  },
  {
    id: "ap-aging-report",
    title: "Accounts Payable (AP) Aging",
    shortTitle: "AP Aging",
    path: "/reports/ap-aging",
    category: "financial",
    categoryLabel: "Financial",
    icon: "fa-solid fa-clock-rotate-left",
    iconBg: "bg-red-50 text-red-700 dark:bg-red-950/50 dark:text-red-300",
    description:
      "Vendor payment aging analysis grouped into time buckets (0-30, 31-60, 61-90, 90+ days) for cashflow management.",
  },
  {
    id: "ar-aging-report",
    title: "Accounts Receivable (AR) Aging",
    shortTitle: "AR Aging",
    path: "/reports/ar-aging",
    category: "financial",
    categoryLabel: "Financial",
    icon: "fa-solid fa-hand-holding-dollar",
    iconBg: "bg-teal-50 text-teal-700 dark:bg-teal-950/50 dark:text-teal-300",
    description:
      "Customer receivables aging schedule, credit terms enforcement, outstanding invoices, and collection forecasts.",
  },
  {
    id: "customer-report",
    title: "Customer Performance",
    shortTitle: "Customer Report",
    path: "/reports/customer-report",
    category: "sales",
    categoryLabel: "Sales",
    icon: "fa-solid fa-user-check",
    iconBg: "bg-indigo-50 text-indigo-700 dark:bg-indigo-950/50 dark:text-indigo-300",
    description:
      "Individual customer account statements, sales ledger history, purchase volume cadence, and payment compliance.",
  },
];
